import { combineReducers, configureStore } from "@reduxjs/toolkit";
import toolReducer from "./tool"
import modelReducer, { modelUndoExcludeAction } from "./model"
import interfaceReducer from "./interface"
import interactionReducer from "./interaction"
import undoable, { excludeAction } from "redux-undo";
import { batchGroupBy } from "./redo_undo/batchActionGroup";

// export const store = configureStore({
//     reducer: {
//         tool: toolReducer,
//         model: modelReducer,
//         interface: interfaceReducer,
//         interaction: interactionReducer,
//     }
// })
const rootReducer = combineReducers(
    {
        tool: toolReducer,
        model: undoable(modelReducer, {
            limit: 25,
            filter: excludeAction(modelUndoExcludeAction),
            groupBy: batchGroupBy.initGroupByFunction([]),
            neverSkipReducer: false, // prevent undoable from skipping the reducer on undo/redo and clearHistoryType actions
            syncFilter: true
        }),
        interface: interfaceReducer,
        interaction: interactionReducer,
    }
)
export const setupStore = (preloadedState?: Partial<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState
    })
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatc
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
